import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { App } from "./App";
import "./index.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// Start the Mock Service Worker in dev so every API call routes to
// the in-memory fixtures under `src/mocks/`. Dynamic import keeps msw
// out of the production bundle. Gated on `import.meta.env.DEV` — the
// same flag used by `DEV_BYPASS` in `auth/session.ts`, so the two
// features are coupled: auth bypass ⇔ mocked API.
async function bootstrap(): Promise<void> {
  if (import.meta.env.DEV) {
    const { worker } = await import("./mocks/browser");
    await worker.start({
      // Pass-through for requests we haven't mocked. We'd rather see
      // a warning than silently fail on something the UI expects to
      // exist.
      onUnhandledRequest: "warn",
    });
    console.info("[MSW] Mocking enabled");
  }

  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>,
  );
}

void bootstrap();
